import AssociatedProject from './AssociatedProject';
import withGS from '../../core/withGShoc';
import PropTypes from 'prop-types';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import GS from '../../grafsync/grafsync';
import ManageAssociatedProject from '../../core/project/ManageAssociatedProject';

class OntologyProjectAssociations extends React.Component {

    onAddProjectAssociation = async (projectIRI) => {
        // There is a small chance that a project could get added twice but it won't break anything
        if (this.props.ontologyProjects && this.props.ontologyProjects.includes(projectIRI)) return;
        const associationIRI = "https://grafsync.graphifi.com/data/association/" + uuidv4();
        const newAssociation = {
            id: associationIRI,
            type: "OntologyProjectAssociation",
            associatedProject: projectIRI
        };
        await GS.insertResource(newAssociation, associationIRI, this.props.graph, [this.props.project]);
        GS.addProperty(this.props.id, this.props.graph, 'ontologyProjectAssociation', associationIRI);
    };

    onDeleteProjectAssociation = (associationIRI) => GS.deleteResource(associationIRI, this.props.graph);

    render() {

        const { data, entitlements, graph , lockedGraphs} = this.props;

        return (
            <ManageAssociatedProject
                associatedProjectComponent={AssociatedProject}
                graph={graph}
                lockedGraphs={lockedGraphs}
                onDeleteProjectAssociation={this.onDeleteProjectAssociation}
                onAddProjectAssociation={this.onAddProjectAssociation}
                entitlements={entitlements}
                data={data}
            />
        );
    }
}

OntologyProjectAssociations.propTypes = {
    id: PropTypes.string.isRequired,
    project: PropTypes.string,
    graph: PropTypes.string.isRequired,
    ontologyProjects: PropTypes.array,
    entitlements: PropTypes.array,
    data: PropTypes.object.isRequired,
    lockedGraphs: PropTypes.array,
};

export default withGS(OntologyProjectAssociations);